export function getB2BToken() {
  try {
    return localStorage.getItem('token_b2b');
  } catch {
    return null;
  }
}

export function getBookingsBaseUrl() {
  const token = getB2BToken();

  return token ? '/api/bookings' : '/api/public/bookings';
}

export function getPaymentsBaseUrl() {
  const token = getB2BToken();

  return token ? '/api/payments' : '/api/public/payments';
}

export function getAuthHeaders() {
  const token = localStorage.getItem('token_b2b');
  const guestToken = localStorage.getItem('booking_guest_token');

  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(!token && guestToken ? { 'X-Booking-Token': guestToken } : {}),
  };
}

export function isB2BMode() {
  return !!getB2BToken();
}
